<template>
  <div class="d-flex footer justify-end mt-1">
    <div class="footer-text">{{ $t('components.pagination.footerText') }}</div>
    <div class="my-auto">
      <v-select
        v-model="itemsPerPage"
        :items="[10, 20, 30, 40, 50]"
        :append-icon="null"
        hide-details
        class="footer-select"
      />
    </div>
    <div class="my-auto">
      <v-pagination
        v-model="page"
        :length="pageCount"
        total-visible="5"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemsPerPage: {
      type: Number,
      default: 10,
      required: true
    },
    page: {
      type: Number,
      default: 1,
      required: true
    },
    total: {
      type: Number,
      default: 0,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    pageCount () {
      return this.itemsPerPage ? Math.ceil(this.total / this.itemsPerPage) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    font-size: 12px;
    color: #A4A6AB;

    &-text {
      margin-right: 12px;
      margin-top: auto;
      margin-bottom: auto;
    }

    &-select {
      width: 24px;
      margin-right: 12px;
      margin-top: auto;
      margin-bottom: auto;
      padding-top: 0;

      & ::v-deep .v-select__selection--comma {
        margin: 7px 0px 7px 4px;
      }

      &.v-text-field>.v-input__control>.v-input__slot {
        &:before {
          border-style: none;
        }

        &:after {
          border-style: none;
        }
      }

      & .v-select__selections {
        color: #A4A6AB !important;
      }
    }
  }
</style>
